function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.357a1.013 1.013 0 01-1.012-1.011H9.655a2.348 2.348 0 001.678 2.247v.874h1.333v-.856a2.095 2.095 0 001.679-2.068c0-1.21-1.06-1.865-1.995-2.443-.7-.433-1.362-.841-1.362-1.309 0-.6.545-.814 1.012-.814a1.013 1.013 0 011.012 1.012h1.333a2.348 2.348 0 00-1.679-2.247v-.875h-1.333v.856a2.095 2.095 0 00-1.678 2.068c0 1.211 1.06 1.866 1.995 2.444.7.432 1.362.84 1.362 1.308 0 .601-.545.815-1.012.815z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 11.2h-3.813a7.992 7.992 0 01-13.174 0H1.6A1.6 1.6 0 000 12.8v9.6A1.6 1.6 0 001.6 24h20.8a1.6 1.6 0 001.6-1.6v-9.6a1.6 1.6 0 00-1.6-1.6zm-3.2 7.467H4.8V16.8h14.4v1.867z",
  fill: "#404040"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 13.333A6.667 6.667 0 1012 0a6.667 6.667 0 000 13.334zM6.4 6.667a5.619 5.619 0 1111.237-.038A5.619 5.619 0 016.4 6.667z",
  fill: "#404040"
});

function SvgCashDepositIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCashDepositIcon;